import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ff52dc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistical" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-warning-outline" }, null, -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_counter_up = _resolveComponent("counter-up")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.panelData.title), 1),
      _createVNode(_component_el_tooltip, {
        content: _ctx.panelData.tips,
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["content"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_counter_up, {
        number: _ctx.panelData.number1,
        option: 
          _ctx.panelData.amount === 'saleroom' ? _ctx.counterOption2 : _ctx.counterOption1
        
      }, null, 8, ["number", "option"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", null, [
        _createTextVNode(_toDisplayString(_ctx.panelData.subtitle) + " ", 1),
        _createVNode(_component_counter_up, {
          number: _ctx.panelData.number2,
          option: 
            _ctx.panelData.amount === 'saleroom' ? _ctx.counterOption2 : _ctx.counterOption1
          
        }, null, 8, ["number", "option"])
      ])
    ])
  ]))
}